import React from "react";
import { Flex, Text } from "@chakra-ui/react";

type ChipColorVariant = "gray" | "blue" | "green" | "yellow" | "red";

interface Props {
  label: string;
  colorVariant?: ChipColorVariant;
}

const CHIP_COLORS: Record<
  ChipColorVariant,
  { color: string; borderColor: string; background: string }
> = {
  gray: { color: "#444440", borderColor: "#D4D4D1", background: "#FCFCFB" },
  blue: { color: "#1272EF", borderColor: "#A8CEFA", background: "#F0F9FF" },
  green: { color: "#16B41C", borderColor: "#A9E0AB", background: "#F0FAEF" },
  yellow: { color: "#B8860B", borderColor: "#F5C79B", background: "#FFF7ED" },
  red: { color: "#EE7D7A", borderColor: "#EE7D7A", background: "#FFEEEE" },
};

// 등록 신청 내역 모달 공용 칩 (요약 카운트/요청번호 표시용)
function PathPickRequestStatusChip({ label, colorVariant = "gray" }: Props) {
  const colors = CHIP_COLORS[colorVariant];

  return (
    <Flex
      padding={"2px 10px"}
      alignItems={"center"}
      borderRadius={"6px"}
      border={`0.5px solid ${colors.borderColor}`}
      background={colors.background}
      flexShrink={0}
    >
      <Text textStyle={"caption-bold"} color={colors.color}>
        {label}
      </Text>
    </Flex>
  );
}

export default PathPickRequestStatusChip;
